import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/reports/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchContainers(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/reports/${agro_exporter_id}/${agro_exporter_process_id}/containers`
    );
  },
  fetchReportProcess(
    agro_exporter_id,
    agro_exporter_process_id,
    agro_exporter_report_id
  ) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/reports/${agro_exporter_id}/${agro_exporter_process_id}/report_process/${agro_exporter_report_id}`
    );
  },
  fetchReportContainer(
    agro_exporter_id,
    agro_exporter_process_id,
    agro_exporter_report_id,
    container_id
  ) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/reports/${agro_exporter_id}/${agro_exporter_process_id}/report_container/${agro_exporter_report_id}/${container_id}`
    );
  }
};
